// src/hooks/useContent.ts
import { useGenericApi } from "./useGenericApi";
import { fetchContent } from "../helpers/apis/apiGetContent";
import { getRoutePathByPageType } from "@shared/helpers/findPathForSystemSite";
import { ContentApiResponse } from "@shared/types/ContentTypes";


const cranePath = getRoutePathByPageType("Crane") || "";

export const useContent = (url: string) => {
    const isLoginPage = /^\/login(\?.*)?$/.test(url.toLowerCase());
    const isCranePage = url.toLowerCase().startsWith(cranePath.toLowerCase());
    
    return useGenericApi<{ data: ContentApiResponse; statusCode: number }, unknown>(
        ["content", url],
        () => fetchContent(url),
        {
            enabled: !isLoginPage && !isCranePage, // Disable query if it's the login page or crane page
            select: (response) => {
                return {
                    data: response.data,
                    statusCode: response.statusCode,
                };
            },
        }
    );
};
